// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zle-","label":"styles_label__8p1cL"};